import { render, staticRenderFns } from "./TextWrapperReplacer.vue?vue&type=template&id=3b827ab8&scoped=true&"
import script from "./TextWrapperReplacer.vue?vue&type=script&lang=ts&"
export * from "./TextWrapperReplacer.vue?vue&type=script&lang=ts&"
import style0 from "./TextWrapperReplacer.vue?vue&type=style&index=0&id=3b827ab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b827ab8",
  null
  
)

/* custom blocks */
import block0 from "./TextWrapperReplacer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports